import React from "react";

const FAQ = () => (
  <div className="flex flex-col items-center justify-center h-screen">
    <h1 className="text-4xl font-bold mb-4">FAQ</h1>
    <p className="text-lg">Coming Soon</p>
  </div>
);

export default FAQ;
